import { LogLevelEnum } from 'shared/core/data-access/log';
import { ThemeEnum } from 'shared/design-system/data-access/theme';
import { BaseConfig } from './base-config.model';

export const baseConfig: BaseConfig = {
    appName: 'shared',
    environmentName: 'fixture',
    apiBasePath: '',
    version: '',
    assetConfigPath: '',
    assetImagePath: '',
    logLevel: LogLevelEnum.ALL,
    defaultTheme: ThemeEnum.LIGHT,
    mapKey: '',
    storageKey: '',
};
